import Vue from "vue"
import { Notification as NotificationV  } from "element-ui";

let webSocket = null
let sourceId = null
let checkMsg = {
    eventType: 'pcHeartbeat',
    sourceId: null,
    data: '我是心跳消息拜托不要处理我'
}

// 创建webSocket连接
let createWebSocket = (urls, baseUrl, sourceIdV) => {
    // 是否重复
    if (webSocket && (webSocket.readyState === WebSocket.OPEN || webSocket.readyState === WebSocket.CONNECTING)) {
        console.warn('WS 已连接或正在连接，跳过重复创建');
        return;
    }
    if (webSocket) {
        closeWebSocket();
    }
    sourceId = sourceIdV
    let url = ''
    try {
        if (!"WebSocket" in window) {
            console.error("当前游览器不支持WS")
            return;
        }
        // 可以传地址,不传默认指定服务端地址
        if (urls == undefined) {
            if (window.location.protocol === 'http:') {
                url = "ws://"+ window.location.host + baseUrl +"/ws?"
                // url = "ws://127.0.0.1:8010" + baseUrl + "/ws?"
            } else {
                url = "wss://" + window.location.host + baseUrl + "/ws?"
            }
        } else {
            url = urls;
        }
        webSocket = new WebSocket(url + "token=" + Vue.cookie.get('TmsToken'))
        // 初始化websocket连接
        webSocket.onopen = onopenWS
        webSocket.onclose = oncloseWS
        webSocket.onerror = onerrorWS
        webSocket.onmessage = onmessageWS
    } catch (e) {
        console.error('尝试创建WS连接失败');
        // 如果无法连接上webSocket 那么重新连接！可能会因为服务器重新部署，或者短暂断网等导致无法创建连接
        reConnect();
    }
}

// 连接成功后触发
export function onopenWS(e) {
    console.error('WS开始了连接');
    checkMsg.sourceId = sourceId
    webSocket.send(JSON.stringify(checkMsg));
    isConnect = true;
    heartCheck.start();
}

// 连接关闭后或者异常关闭触发
export function oncloseWS(e) {
    console.error('WS连接关闭/异常关闭');
    isConnect = false;
}

// 连接失败后触发
export function onerrorWS(e) {
    console.error('WS连接失败');
    isConnect = false;
    reConnect();
}

// 接收服务端信息触发
export function onmessageWS(e) {
    // window.dispatchEvent(new CustomEvent('onmessageWS', {
    //       detail: {
    //       data: e
    //     }
    //   }))
    try {
        if (e) {
            let parseE = JSON.parse(e.data)
            if (parseE.eventType == 'ORDER_INFO') {
                // 系统内通知
                NotificationV({
                    title: '📦 订单提醒消息',
                    type: 'success',
                    duration: 0,
                    dangerouslyUseHTMLString: true,
                    message: parseE.data
                })

                // 游览器通知
                // showGoogleNotification(parseE.data,'📦 订单提醒消息');
            }
        }
    }
    catch (e) {
        console.warn('WS 接收服务端消息处理错误!', e)
    }


    //获取消息后 重置心跳
    heartCheck.reset();
}
function showGoogleNotification(messageText,title) {
    // 1. 检查浏览器是否支持通知
    if (!window.Notification) {
        console.warn('当前浏览器不支持桌面通知');
        return;
    }

    // 2. 检查授权状态
    if (Notification.permission === 'granted') {
        // 已授权，直接显示通知
        createNotification(messageText,title);
    }
    else if (Notification.permission !== 'denied') {
        // 未授权且未被拒绝，请求授权
        Notification.requestPermission().then(permission => {
            if (permission === 'granted') {
                createNotification(messageText,title);
            }
        });
    }
}
function createNotification(messageText,title) {
    // 限制消息长度，避免通知过长
    const maxLength = 100;
    const bodyText = messageText.length > maxLength ? messageText.substring(0, maxLength) + '...' : messageText;
    const notification = new Notification(title, {
        body: bodyText,
        tag: 'order_notification',
        requireInteraction: false,
        silent: false,
        vibrate: [200, 100, 200]
    });

    // 点击通知时的行为
    notification.onclick = function() {
        window.focus();
        // window.location.href = '/order/list';
        notification.close();     // 点击后关闭通知
    };

    // 通知自动关闭后的回调
    notification.onclose = function() {
    };

    setTimeout(() => {
        notification.close();
    }, 10000);
}

// 连接标识 避免重复连接
let isConnect = false

// 断线重连后，延迟5秒重新创建WebSocket连接  rec用来存储延迟请求的代码
let rec

// 定义重连函数
let reConnect = () => {
    console.warn('尝试WS重新连接');
    // 如果已经连上就不在重连了
    if (isConnect) return;
    rec && clearTimeout(rec);
    // 延迟5秒重连  避免过多次过频繁请求重连
    rec = setTimeout(function () {
        createWebSocket();
    }, 5000);
}

// 心跳设置
let heartCheck = {
    // 每段时间发送一次心跳包 这里设置为50s
    timeout: 50000,
    // 延时发送消息对象（启动心跳新建这个对象，收到消息后重置对象）
    timeoutObj: null,
    // 一段时间后发送心跳包
    start: function () {
        this.timeoutObj = setTimeout(function () {
            if (isConnect) {
                checkMsg.sourceId = sourceId
                webSocket.send(JSON.stringify(checkMsg));
            }
        }, this.timeout);
    },
    //  接收到服务器的信息之后要重置心跳发送的方法
    reset: function () {
        clearTimeout(this.timeoutObj);
        this.start();
    },
}

// 关闭连接
let closeWebSocket = () => {
    if (webSocket != null) {
        webSocket.close();
    }
}

// 获取当前连接状态
let getConnectionStatus = () => {
    return {
        isConnected: isConnect,
        readyState: webSocket ? webSocket.readyState : -1
    }
}

// 发送消息
let sendMessage = (message) => {
    if (webSocket && isConnect && webSocket.readyState === 1) {
        webSocket.send(JSON.stringify(message))
        return true
    }
    console.warn('WS 未连接，无法发送消息')
    return false
}

export default {
    createWebSocket: createWebSocket,
    closeWebSocket: closeWebSocket,
    getConnectionStatus: getConnectionStatus,
    sendMessage: sendMessage
}

